import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SelectField from './SelectField';


class LocationField extends Component {
    _getOptions () {
        return this.props.locationsList.map((l) => ({
            label: `${l.city}, ${l.region} ${l.countryCode}`,
            value: l.standardLocationId,
            ref: l
        }));
    }

    render () {
        const { account, location } = this.props.entry;

        return (
            <SelectField
                colClass={this.props.colClass}
                disabled={this.props.locationsList.length === 0}
                hasError={this.props.hasError}
                hidden={this.props.fieldPermission === 'hidden'}
                label="Location"
                onChange={(option) => this.props.onSelectLocation(option)}
                options={this._getOptions()}
                placeholder={(account.accountId) ? "Select from the drop down" : "Select account first"}
                required={this.props.fieldPermission === 'required'}
                value={(location) ? location.standardLocationId : null}
            />
        );
    }
}


LocationField.propTypes = {
    colClass: PropTypes.string.isRequired,
    entry: PropTypes.object.isRequired,
    fieldPermission: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    locationsList: PropTypes.array.isRequired,
    onSelectLocation: PropTypes.func.isRequired,
};


export default LocationField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/LocationField.jsx